export default __webpack_public_path__ + "static/media/13.b4d05de3.jpg";